import React, { FC } from 'react';

import { RobokassaMethod } from '~/api/finance/financeApiTypes';
import {
  DefaultMethodPaymentParams,
  MethodPaymentTemplate,
} from '~/feature/finance/BuyingSteps/ChoosePay/MethodPayments/MethodPaymentTemplate';
import { RobokassaMethodPaymentIcon } from '~/feature/finance/BuyingSteps/ChoosePay/MethodPayments/RobokassaMethodPayment/RobokassaMethodPaymentIcon';

interface RobokassaMethodPaymentProps extends DefaultMethodPaymentParams {
  method: RobokassaMethod;
  isHide?: boolean;
}

export const RobokassaMethodPayment: FC<RobokassaMethodPaymentProps> = ({
  method,
  onCheck,
  isHide = false,
  ...props
}) => {
  if (isHide) {
    return <></>;
  }

  return (
    <MethodPaymentTemplate
      Logo={(
        <>
          <RobokassaMethodPaymentIcon width="48px" height="48px" fill="#28B446" />
        </>
      )}
      Text={(
        <>
          Карты другой страны
        </>
      )}
      onCheck={() => {
        if (onCheck) {
          onCheck(method);
        }
      }}
      {...props}
    />
  );
};
